import React, { Fragment } from 'react';
import cx from 'classnames';
import BaseForm from '../../../../../components/form/BaseForm';
import CheckboxGroup from '../../../../../components/input/CheckBoxGroup/CheckBoxGroup';
import ButtonList from '../../../../../components/ButtonList';
import {
  PRODUCT_PAY_CARD_OPTION_BUTTON_LIST,
  PRODUCT_PAY_METHOD_SELECT_LIST,
  PRODUCT_PAY_METHOD_TYPE_SELECT_LIST,
  PRODUCT_PAY_METHOD_VALUE_TYPE,
} from '../../../../../constants/service/app/productConstants';
import { compareProductVersion } from '../../../../../lib/utils';

const ProductDetailPayMethodTypeInfo = (props) => {
  const {
    isEditable,
    onChange,
    productPayMethodTypeId,
    showProductPayMethodTypeIdSubContent,
    productPayMethodList,
    card,
    isCompare,
    comparisonData,
  } = props;

  return (
    <Fragment>
      <BaseForm
        className={isCompare && compareProductVersion(productPayMethodTypeId, comparisonData.productPayMethodTypeId)}
        label="상품 결제 타입"
        content={
          <ButtonList
            current={productPayMethodTypeId}
            list={PRODUCT_PAY_METHOD_TYPE_SELECT_LIST}
            onClick={onChange}
            disabled={!isEditable}
          />
        }
        subContent={
          showProductPayMethodTypeIdSubContent ? (
            <span className="primary">
              *상품의 형태에 따라 결제 가능수단이 변경되므로 반드시 확인해주시기 바랍니다.
            </span>
          ) : null
        }
      />

      <BaseForm
        className={isCompare && compareProductVersion(productPayMethodList, comparisonData.productPayMethodList)}
        label="결제 가능 수단"
        content={<CheckboxGroup value={productPayMethodList} list={PRODUCT_PAY_METHOD_SELECT_LIST} disabled={true} />}
      />

      {card !== PRODUCT_PAY_METHOD_VALUE_TYPE.UN_USED ? (
        <BaseForm
          className={cx('card-option', isCompare && compareProductVersion(card, comparisonData.card))}
          label="카드 옵션"
          content={<ButtonList current={card} list={PRODUCT_PAY_CARD_OPTION_BUTTON_LIST} disabled={true} />}
          subContent={
            card === PRODUCT_PAY_METHOD_VALUE_TYPE.PART ? (
              <Fragment>
                <div>일부 선택 시, 결제 가능한 카드사는 다음과 같습니다.</div>
                <div className="primary">비씨, KB국민, 농협, 신한</div>
              </Fragment>
            ) : null
          }
        />
      ) : null}
    </Fragment>
  );
};

export default ProductDetailPayMethodTypeInfo;
